export {default} from './Button.js';



// WEBPACK FOOTER //
// ./~/wix-style-react/src/Backoffice/Button/index.js